import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { shawneeKsConfig } from "./data";

export default function ShawneeKsPage() {
  return <CityPageTemplate config={shawneeKsConfig} />;
}